/**
 * @fileoverview Agent definition for character-ideation-v2.
 *
 * This agent generates a list of major and minor character ideas
 * from a story outline.
 *
 * Supports two context modes:
 * - Traditional: Uses storyContext (which includes writtenPlot)
 * - Structured: Also accepts storyStructure from storylines-planner-v1
 *   for structurally-aware character ideation in the split-planner pipeline
 *
 * @category entities.characters.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-ideation-v2',
  kind: 'primitive',
  name: 'Character Ideation',
  description: 'Generates a list of major and minor character ideas from your story outline.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-03',
    taxonomyPath: 'entities.characters.creation',
    usedBy: [
      'use-character-ideation-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-details-ideation-v2',
      'character-details-multimodal-generator-v3',
      'storylines-planner-v1',
    ],
  },
};
